<template>
  <div class="relative flex min-h-screen w-full flex-col items-center bg-base dark:bg-background-dark">

    <!-- Top Navigation Bar -->
    <header class="flex h-20 w-full items-center justify-center border-b border-content/10 px-4 md:px-10">
      <div class="flex w-full max-w-5xl items-center justify-between">
        <div class="flex items-center gap-4 text-content">
          <h1 class="text-content text-lg font-bold leading-tight tracking-[-0.015em]">{{ $t('login.title') }}</h1>
        </div>
      </div>
    </header>

    <!-- Main Content -->
    <main class="flex w-full max-w-5xl flex-1 flex-col items-center justify-center p-4 py-16">
      <div class="w-full max-w-2xl rounded-xl bg-surface dark:bg-surface/50 p-6 md:p-10 border border-line dark:border-roundBorder">

        <!-- Page Heading -->
        <div class="mb-8 text-center">
          <p class="text-content text-3xl md:text-4xl font-black leading-tight tracking-[-0.033em]">{{ $t('account.finish.title') }}</p>
          <p class="text-gray-400 dark:text-muted text-base font-normal leading-normal mt-2">{{ $t('account.finish.titleSub') }}</p>
        </div>

        <!-- Progress Steps -->
        <div class="flex justify-center gap-2 mb-8">
          <div class="px-4 py-2 rounded-lg bg-content/5 text-muted text-grid-btn">{{ $t('account.common.agree') }}</div>
          <div class="px-4 py-2 rounded-lg bg-content/5 text-muted text-grid-btn">{{ $t('account.common.info') }}</div>
          <div class="px-4 py-2 rounded-lg bg-primary text-white text-grid-btn font-bold">{{ $t('account.common.complete') }}</div>
        </div>

        <!-- Success Icon -->
        <div class="flex justify-center mb-8">
          <div class="w-24 h-24 rounded-full bg-primary/20 flex items-center justify-center">
            <svg class="w-12 h-12 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
        </div>

        <!-- Completion Message -->
        <div class="text-center mb-8">
          <p class="text-content text-xl font-bold mb-2">{{ $t('account.finish.congratulations') }}</p>
          <p class="text-gray-400 dark:text-muted text-sm leading-relaxed">
            {{ $t('account.finish.message') }}
          </p>
        </div>

        <!-- Login Button -->
        <div class="pt-4">
          <button
            @click="goToLogin()"
            class="flex w-full cursor-pointer items-center justify-center overflow-hidden rounded-lg h-14 px-4 text-base font-bold leading-normal tracking-[0.015em] bg-primary text-white hover:bg-primary/90"
          >
            <span class="truncate">{{ $t('account.finish.goToLogin') }}</span>
          </button>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: "FinishJoin",
  methods: {
    goToLogin() {
      // client=unity 판단: URL param 우선, 없으면 진입 시(Agree) 저장한 localStorage 폴백(다단계 이동 중 param 유실 대비).
      let client = new URLSearchParams(window.location.search).get('client');
      try {
        if (client !== 'unity' && localStorage.getItem('signupClient') === 'unity') client = 'unity';
        localStorage.removeItem('signupClient'); // 사용 후 정리
      } catch (e) { /* 무시 */ }

      if (window.Android && typeof window.Android.onForgotPasswordBackToLogin === 'function') {
        window.Android.onForgotPasswordBackToLogin();
      }
      else if (client === 'unity') {
        window.location.href = 'metadexter://login'; // Unity(모바일) 앱으로 복귀
        return;
      }
      else {
        this.$router.push('/login');
      }
    },
  },
}
</script>

<style scoped>
/* Component-specific styles if needed */
</style>
